import { useTranslation } from 'react-i18next';

interface SpecItem {
  label: string;
  value: string;
}

interface SpecsPanelProps {
  specifications: SpecItem[];
}

export default function SpecsPanel({ specifications }: SpecsPanelProps) {
  const { t } = useTranslation('products');
  if (!specifications || specifications.length === 0) {
    return (
      <div className="border border-ink-100 rounded-lg p-6 text-center">
        <p className="text-sm text-ink-400">{t('detail.noSpecs')}</p>
      </div>
    );
  }

  return (
    <div className="border border-ink-100 rounded-lg overflow-hidden">
      <div className="divide-y divide-ink-100">
        {specifications.map((spec, idx) => (
          <div
            key={idx}
            className={`flex items-center px-4 py-3 ${
              idx % 2 === 0 ? 'bg-white' : 'bg-cream-50/70'
            }`}
          >
            <span className="text-sm text-ink-400 w-[45%] shrink-0 font-medium">
              {spec.label}
            </span>
            <span className="text-sm text-ink-700 font-semibold">
              {spec.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}